module.exports = __webpack_public_path__ + "img/hic-leukaemia-male.756252af.png";